import { render, staticRenderFns } from "./ViSchoolOverview.vue?vue&type=template&id=d7091a7e&scoped=true"
import script from "./ViSchoolOverview.vue?vue&type=script&lang=js"
export * from "./ViSchoolOverview.vue?vue&type=script&lang=js"
import style0 from "./ViSchoolOverview.vue?vue&type=style&index=0&id=d7091a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7091a7e",
  null
  
)

export default component.exports